import axios from 'axios'
import config from './config'

let baseURL = config.baseURL
let baseContext = config.baseContext
let accessKeyID = config.accessKeyID
let accessKey = config.accessKey
let cloudBaseURL = config.cloudBaseURL
let headers = {
  userId : localStorage.getItem('login_userid_app'),
  userToken : localStorage.getItem('login_token_app')
}

//let loginUrl =  config.loginUrl
const API = {
  getBaseContext () {
    return baseContext
  },
  getAccessInfo () {
    return {
      accessKey: accessKey,
      accessKeyID: accessKeyID
    }
  },
  getBaseUrRl () {
    return baseURL
  },
   // 根据userid获取用户信息
   getuser(param){
    let url =baseURL+ 'user/userService/userInfo'
    // console.log(param)
    return axios.post(url, '' ,{ headers: {"userId": param.userId, "appchannel": param.channelId}})
  },
  // 获取用户邀请记录
  // getmyInviteDetail(param){
  //   let url = baseURL+'member/invitedNew/v1.0.0.6/myInviteDetail'
  //   return  axios.post(url , param, {headers:headers})
  // },
  //获取手机号
  getuserinfo(param){
    let url = baseURL+'h5/inviteNew/v1.0.0.7/queryshareUserInfo'
    return  axios.post(url , param.data, {headers:param.headers})
  },
  //提交手机号
  submitphone(param){
    let url = baseURL+'h5/inviteNew/v1.0.0.7/submitInvitedNew'
    return  axios.post(url , param.data, {headers:param.headers})
  },
  //获取分享信息
  queryShareInfo(param){
    let url = baseURL + 'user/shareInfo/queryShareInfo'
    return axios.post(url, param,{headers:param.header})
  },
  //经分统计：通过userId查询
  getUserInfoByUserId(param){
    let url = baseURL + 'user/userService/getUserInfoByUserId'
    return axios.post(url, param.data, { headers: param.headers })
  },
  //经分统计：登录权益
  postJinFenLogin (param) {
    let url = baseURL + 'user/userService/createUserLoginInfo'
    return axios.post(url, param.data, { headers: param.headers })
  },
  //经分统计：添加事件
  postJinFenEvent (param) {
    let url = baseURL + 'report/bilog/addClientEvent'
    return axios.post(url, param.data, { headers: param.headers })
  },
  //中奖轮播内容
  getWinnerList () {
    let url = baseURL + 'h5/inviteNew/v1.0.2.7/queryRotationPrizes'
    return axios.post(url, {}, { headers: {appType:'4'} })
  },
  //规则内容
  getRuleContent (param) {
    let url = baseURL + 'game/copywriting/v1.0.2.5/queryCopyWriting'
    return axios.post(url, param.data, { headers: {appType:'4'} })
  },
  // 获取用户邀请记录
  getInviteList (param) {
    let url = baseURL + 'h5/inviteNew/v1.0.2.7/queryMyInviteDetail'
    return axios.post(url, param.data, { headers: param.headers })
  },
  //奖品列表
  getMyPrizeList (param) {
    let url = baseURL + 'h5/inviteNew/v1.0.2.7/queryMyPrizes'
    return axios.post(url, param.data, { headers: param.headers })
  },
  //查询收货地址
  getMyAddress (param) {
    let url = baseURL + 'h5/inviteNew/v1.0.2.7/queryDeliveryAddress'
    return axios.post(url, param.data, { headers: param.headers })
  },
   //提交收货地址
   saveMyAddress (param) {
    let url = baseURL + 'h5/inviteNew/v1.0.2.7/submitDeliveryAddress'
    return axios.post(url, param.data, { headers: param.headers })
  },
}

export default API



// WEBPACK FOOTER //
// ./src/api/api.js